import { Component, inject, OnInit } from '@angular/core';
import { SelectModule } from 'primeng/select';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from '../../core/decorators/auto-unsubscribe.decorator';
import { TRANSLATION_CONSTANTS } from '../../core/constants/translation';
import { TranslationSetupService } from '../../core/services/translation-setup.service';
import { ToastService } from '../../core/services/toast.service';

@AutoUnsubscribe('subs')
@Component({
  selector: 'app-language-picker',
  imports: [SelectModule, ReactiveFormsModule, TranslatePipe],
  templateUrl: './language-picker.component.html',
})
export class LanguagePickerComponent implements OnInit {
  subs: Subscription = new Subscription();
  languageOptions = TRANSLATION_CONSTANTS.LANGUAGE_OPTIONS;
  form!: FormGroup;
  translationSetup = inject(TranslationSetupService);
  translate = inject(TranslateService);
  toastService = inject(ToastService);
  ngOnInit() {
    const initialLanguage = this.translate.getCurrentLang();
    this.form = new FormGroup({
      language: new FormControl(initialLanguage),
    });
    this.subs.add(
      this.form.get('language')?.valueChanges.subscribe((value) => {
        const success = this.translationSetup.updateLanguage(value);
        if (!success) {
          this.form.get('language')?.setValue(initialLanguage);
          this.toastService.addError({
            detail: this.translate.instant('common.failedToChangeLanguage'),
          });
        } else {
          this.toastService.addSuccess({
            detail: this.translate.instant('common.languageChanged'),
          });
        }
      }),
    );
  }
}
